import React, {useCallback, useEffect, useState} from "react";
import ReactDataGrid from '@inovua/reactdatagrid-enterprise';
import '@inovua/reactdatagrid-enterprise/base.css';
import '../../assets/default-light.scss'
import styled from "styled-components";
import {ColSpan2, RowSpan, SaveExcelButton} from "../../assets/GlobalStyles";
import {useAtom, useAtomValue} from "jotai";
import {rowDetailsDataAtom, tableIdAtom} from "../../pages/reports/entity/common";
import {exportCSV} from "../reports/ExportCSV";

function RowDetails (props) {
  const [tableId, setTableId] = useAtom(tableIdAtom)
  const rowDetailsData = useAtomValue(rowDetailsDataAtom)
  const [gridRef, setGridRef] = useState(null);
  useEffect(() => {
    setTableId(props.entity)
  }, []);
  /**
   * ...reference react data grid
   * auto size column size to fit
   */
  useEffect(() => {
    if(gridRef){
      gridRef.current.setColumnSizesToFit()
    }
  }, [gridRef])
  const renderRowContextMenu = (menuProps, { rowProps }) => {
    menuProps.autoDismiss = true
  }
  const emptyText = <p style={{fontSize: 16}}>{'데이터가 없습니다.' }</p>
  return (
      <ReactDataGrid
          licenseKey={process.env.REACT_APP_DATA_GRID_LICENSE_KEY}
          handle={setGridRef}
          dataSource={rowDetailsData}
          columns={props.detailColumn}
          enableColumnAutosize={true}
          groups={props.detailGroups}
          showZebraRows={false}
          emptyText={emptyText}
          activeCell={null}
          style={{marginLeft: '50px'}}
          renderRowContextMenu={renderRowContextMenu}
      />
  )
}
function TableDetail (props) {
  const {columns, data, settings, groups, rowExpandHeight, fileName } = props
  const [gridRef, setGridRef] = useState(null);
  const [, setGridDetailRef] = useState(null);
  const gridStyle = { minHeight: 550 }

  /**
   * ...빈 데이터 텍스트
   * @type {JSX.Element}
   */
  const emptyText = <p style={{
    fontSize: 16,
  }}>{props.emptyText !== undefined ? props.emptyText : '데이터가 없습니다.' }</p>

  /**
   * 컬럼 기본 세팅
   */
  const columnData = () => {
    columns.map(item =>
      Object.assign(item, settings.default)
    )
    settings.setColumns.map(item => {
      Object.assign(columns[item.target],item.value)
      Object.assign(columns[item.target],item.function)
      return null
    })
  }

  /**
   * 기본 세팅 시작 설정
   */
  useEffect(() => {
    if(settings !== undefined) {
      columnData()
    } else {
      columns.map(item =>
        Object.assign(item, {textAlign: 'center'})
      )
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  /**
   * ...reference react data grid
   * auto size column size to fit
   */
  useEffect(() => {
    if(gridRef){
      gridRef.current.setColumnSizesToFit()
    }
  },[gridRef])
  /**
   * 오른쪽 클릭 방지
   * @param menuProps
   * @param rowProps
   */
  const renderRowContextMenu = (menuProps, { rowProps }) => {
    menuProps.autoDismiss = true
    console.log('오른쪽 클릭 방지')
  }

  /**
   * ...펼쳐보기
   * @param data
   * @returns {JSX.Element}
   */
  const renderContactsGrid = useCallback(({data}) => {
    return (
        <RowDetails entity={data} detailColumn={props.detailColumn} detailGroups={props.detailGroups}/>
    );
  }, [])

  return(
    <>
      {props.downloadList &&
          <RowSpan style={{justifyContent: 'flex-end'}}>
            <SaveExcelButton onClick={()=>exportCSV(gridRef, fileName)}>엑셀 저장</SaveExcelButton>
          </RowSpan>
      }
      <RowSpan>
        <ColSpan2 style={{paddingLeft: 0}}>
          {props.totalCount && <TotalCount><span/>총 <span>{props?.totalCount[0]}</span> 건의 {props?.totalCount[1]}</TotalCount> }
        </ColSpan2>
        <Small>* shift를 누른 상태에서 스크롤시 좌우 스크롤이 가능합니다.</Small>
      </RowSpan>
      <ReactDataGrid
        licenseKey={process.env.REACT_APP_DATA_GRID_LICENSE_KEY}
        handle={setGridRef}
        style={gridStyle}
        rowExpandHeight={rowExpandHeight}
        rowHeights={45}
        renderDetailsGrid={renderContactsGrid}
        enableColumnAutosize={true}
        emptyText={emptyText}
        idProperty={props.idProperty}
        dataSource={data}
        columns={columns}
        groups={groups}
        pagination={props.pagination}
        livePagination={props.livePagination}
        scrollThreshold={props.scrollThreshold}
        showColumnMenuLockOptions={false}
        showColumnMenuGroupOptions={false}
        limit={30}
        showHoverRows={true}
        multiRowExpand={false}
        activeCell={null}
        renderRowContextMenu={renderRowContextMenu}
        {...props}
      />
    </>
  )
}

export default TableDetail

const Small = styled.small`
  display: inline-block;
  width: 100%;
  text-align: right;
  padding: 10px;
`

export const TotalCount = styled.div`
  display: flex;
  align-items: center;
  & > span:first-child {
    width: 3px;
    height: 12px;
    background-color: #222;
    margin: 2px 8px 0 0;
    display: inline-block;
  }
  & > span:last-child {
    margin-left: 3px;
    color: #ff0000;
  }
`